export default __webpack_public_path__ + "static/gleamauto-5c150a15bf15a5b99e32b5066090f661.png";